import { fileControllerAddToKnowledge } from "@/lib/gen-api";
import { queryKeys } from "@/lib/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useAddLibraryFilesToKnowledgeMutation(
  groupUuid: string | null,
  kitUuid: string | null,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      fileUuids,
      folderUuid,
    }: {
      fileUuids: string[];
      folderUuid: string;
    }) => {
      if (!groupUuid || !kitUuid) {
        throw new Error("Group and workbook are required");
      }

      const results = await Promise.allSettled(
        fileUuids.map((fileUuid) =>
          fileControllerAddToKnowledge({
            path: {
              fileUuid,
            },
            body: { folderUuid },
          }),
        ),
      );

      const added = results.filter(
        (result) => result.status === "fulfilled",
      ).length;
      const failed = results.length - added;

      if (added === 0) {
        throw new Error("Failed to add files to knowledge");
      }

      return { added, failed };
    },
    onSuccess: (_data, variables) => {
      if (!groupUuid || !kitUuid) {
        return;
      }

      queryClient.invalidateQueries({
        queryKey: queryKeys.kitFolders(groupUuid, kitUuid),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.kitFolder(groupUuid, kitUuid, variables.folderUuid),
      });
    },
  });
}
